import React, { useState } from "react";
import MiniCard from "./card/MiniCard";
import ContactFormModal, {
  ContactModalVariant,
} from "../../components/contact-form/ContactFormModal";
import "./Mini.css";
import { fadeIn, staggerContainer } from "../../utils/motion";
import { motion } from "framer-motion";

const miniItems: {
  header: string;
  subHeader: string;
  desc: string;
  modal: ContactModalVariant;
}[] = [
  {
    header: "Relief & Outreach",
    subHeader: "We help people in need.",
    desc: "We belief embracing our own mutual brokenness is central to poverty alleviation so that we can truly help others without hurting them and ourselves. We'd love to know more about your situation...",
    modal: "outreach",
  },
  {
    header: "Partner With Us",
    subHeader: "",
    desc: "We would love to engage with diverse partners in different ways including partnerships to implement a programme, working in consortia, short or long-term strategic partnership. We believe that in partnership with other organizations, together we can empower Christians, improve projects and services...",
    modal: "partnership",
  },
  {
    header: "Volunteer Your Time",
    subHeader: "How can you help? ",
    desc: "There are many different ways to volunteer, depending on your interests and availability. Some common options include: Providing direct services to individuals in need, assist with administrative tasks such as answering phones or organizing events...",
    modal: "volunteer",
  },
];

const Mini: React.FC = () => {
  const [modal, setModal] = useState<ContactModalVariant | null>(null);

  return (
  <motion.section
    className="mini-section"
    variants={staggerContainer(0.2, 0.3)}
    initial="hidden"
    whileInView="show"
    viewport={{ once: false, amount: 0.25 }}
  >
    <motion.div
      className="mini-card-list"
      variants={fadeIn("up", "spring", 0.1, 0.8)}
    >
      {miniItems.map((item, idx) => (
        <MiniCard
          key={idx}
          header={item.header}
          subHeader={item.subHeader}
          desc={item.desc}
          onViewMore={() => setModal(item.modal)}
        />
      ))}
    </motion.div>
    <ContactFormModal variant={modal} onClose={() => setModal(null)} />
  </motion.section>
  );
};

export default Mini;
